import React, { useState, useEffect } from "react";
import Header from "../headers/header";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../contexts/theme";
import FormatLineChart from "../../visualizations/FormatLineChart";
import { GetPastData } from "../../forge/main";
import { GetCurrentTime } from "../global/GetCurrentTime";
import convertToKST from "../global/convertToKST";
import DatePicker from "../global/DatePicker";

const Vibration = () => {
  const [t1data1, setT1Data1] = useState([]);
  const [t1data2, setT1Data2] = useState([]);
  const [t2data1, setT2Data1] = useState([]);
  const [t2data2, setT2Data2] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const tunnel1 = 225435;
  const tunnel2 = 225441;

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const primaryColor = colors.primary[400];
  const redAccentColor = colors.redAccent[300];
  const [bgColor1, setBgColor1] = useState(primaryColor);
  const [bgColor2, setBgColor2] = useState(primaryColor);


  const title_str = "VIBRATION";
  const subtitle_str = [
    `진동을 측정합니다. 총 2개 센서로부터 데이터를 받습니다.`,
  ];

  const DataChange = (lists) => {
    let ret1 = [];
    let ret2 = [];
    if (lists.length === 0) return [ret1, ret2];

    let freX = { id: "X", color: "hsl(231, 70%, 50%)", data: [] };
    let freY = { id: "Y", color: "hsl(217, 70%, 50%)", data: [] };
    let freZ = { id: "Z", color: "hsl(139, 70%, 50%)", data: [] };

    let velX = { id: "X", color: "hsl(231, 70%, 50%)", data: [] };
    let velY = { id: "Y", color: "hsl(217, 70%, 50%)", data: [] };
    let velZ = { id: "Z", color: "hsl(139, 70%, 50%)", data: [] };

    let state = false;

    for(let i=0; i<lists.length; i++){
      if(!('Data' in lists[i]) || !('MessageDate' in lists[i])) continue;

      const timestamp = parseInt(lists[i]["MessageDate"].match(/\d+/)[0], 10);
      const date = new Date(timestamp);

      const list_data = lists[i]["Data"].split('|');
      if (list_data.length < 6) continue;

      freX.data.push({ x: date, y: Number(list_data[0]) });
      freY.data.push({ x: date, y: Number(list_data[1]) });
      freZ.data.push({ x: date, y: Number(list_data[2]) });

      velX.data.push({ x: date, y: Number(list_data[3]) });
      velY.data.push({ x: date, y: Number(list_data[4]) });
      velZ.data.push({ x: date, y: Number(list_data[5]) });

      if ("State" in lists[i] && lists[i]["State"] === 2) {
        state = true;
      }
    }
    ret1.push(freX, freY, freZ);
    ret2.push(velX, velY, velZ);
    return { data1: ret1, data2: ret2, state };
  };

  useEffect(() => {
    const [Tfrom, Tto] = GetCurrentTime();
    const KSTfrom = convertToKST(Tfrom);
    const KSTto = convertToKST(Tto);
    setFrom(KSTfrom);
    setTo(KSTto);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response1 = await GetPastData(tunnel1, from, to);
        const response2 = await GetPastData(tunnel2, from, to);

        const d1 = DataChange(response1.Result);
        const d2 = DataChange(response2.Result);

        setT1Data1(d1.data1);
        setT1Data2(d1.data2);
        setT2Data1(d2.data1);
        setT2Data2(d2.data2);

        setBgColor1(d1.state ? redAccentColor : primaryColor);
        setBgColor2(d2.state ? redAccentColor : primaryColor);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (from && to) {
      fetchData();
    }
  }, [from, to, primaryColor, redAccentColor]);

  return (
    <div>
      <Header title={title_str} subtitle={subtitle_str} />
      <Box>
        <DatePicker from={from} to={to} setFrom={setFrom} setTo={setTo} />
      </Box>
      <Box className="main-box" backgroundColor={bgColor1}>
        <Box className="main-box-detail">
          <Box>
            <Typography variant="h3" fontWeight="600" color={colors.grey[100]}>
              Tunnel-1 진동 데이터
            </Typography>
          </Box>
        </Box>
        <Box className="main-box-graph">
          <Typography variant="h6" fontWeight="500" color={colors.greenAccent[400]} sx={{ marginLeft: "10px", display: "inline-flex" }}>
            Frequency (단위: Hz)
          </Typography>
          {t1data1 && (
            <FormatLineChart data={t1data1} is_dashboard={false} y_label={"time"} />
          )}
        </Box>
        <Box className="main-box-graph">
          <Typography variant="h6" fontWeight="500" color={colors.greenAccent[400]} sx={{ marginLeft: "10px", display: "inline-flex" }}>
            Velocity (단위: mm/s)
          </Typography>
          {t1data1 && (
            <FormatLineChart data={t1data2} is_dashboard={false} y_label={"time"} />
          )}
        </Box>
      </Box>

      <Box className="main-box" backgroundColor={bgColor2} >
        <Box className="main-box-detail">
          <Box>
            <Typography variant="h3" fontWeight="600" color={colors.grey[100]}>
              Tunnel-2 진동 데이터
            </Typography>
          </Box>
        </Box>
        <Box className="main-box-graph">
          <Typography variant="h6" fontWeight="500" color={colors.greenAccent[400]} sx={{ marginLeft: "10px", display: "inline-flex" }}>
            Frequency (단위: Hz)
          </Typography>
          {t1data1 && (
            <FormatLineChart data={t2data1} is_dashboard={false} y_label={"time"} />
          )}
        </Box>
        <Box className="main-box-graph">
          <Typography variant="h6" fontWeight="500" color={colors.greenAccent[400]} sx={{ marginLeft: "10px", display: "inline-flex" }}>
            Velocity (단위: mm/s)
          </Typography>
          {t1data1 && (
            <FormatLineChart data={t2data2} is_dashboard={false} y_label={"time"} />
          )}
        </Box>
      </Box>
    </div>
  );
};

export default Vibration;
